/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

import type { CarpsaleManagementEditItemResponse } from './CarpsaleManagementEditItemResponse';

export type CarpsaleManagementEditItemResponseApiRespoonse = {
    data?: CarpsaleManagementEditItemResponse;
    status?: CarpsaleManagementEditItemResponseApiRespoonse.status;
    message?: string;
    errors?: Record<string, Array<string>>;
};

export namespace CarpsaleManagementEditItemResponseApiRespoonse {

    export enum status {
        SUCCESS = 'success',
        ERROR = 'error',
    }


}

